import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/useAuth';
import { SUPPORTED_LOCALES, LOCALE_LABELS } from '../i18n';
export default function Register() {
    const { t, i18n } = useTranslation();
    const { register } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [locale, setLocale] = useState(i18n.resolvedLanguage ?? 'en');
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);
    const onSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setBusy(true);
        try {
            await register(email, password, locale);
            nav('/dashboard');
        }
        catch {
            setError(t('common.error'));
        }
        finally {
            setBusy(false);
        }
    };
    return (_jsxs("section", { className: "card form-card", children: [_jsx("h1", { children: t('register.title') }), _jsxs("form", { onSubmit: onSubmit, children: [_jsxs("label", { children: [t('common.email'), _jsx("input", { type: "email", required: true, value: email, onChange: (e) => setEmail(e.target.value) })] }), _jsxs("label", { children: [t('common.password'), _jsx("input", { type: "password", required: true, minLength: 10, value: password, onChange: (e) => setPassword(e.target.value) })] }), _jsxs("label", { children: [t('common.language'), _jsx("select", { value: locale, onChange: (e) => setLocale(e.target.value), children: SUPPORTED_LOCALES.map((l) => (_jsx("option", { value: l, children: LOCALE_LABELS[l] }, l))) })] }), error && _jsx("p", { className: "error", children: error }), _jsx("button", { type: "submit", className: "btn btn-primary", disabled: busy, children: busy ? t('common.loading') : t('register.submit') })] }), _jsx("p", { children: _jsx(Link, { to: "/login", children: t('register.haveAccount') }) })] }));
}
